@if (isMaintenanceMode) {
<main class="maintenance-page" aria-live="polite">
  <section class="maintenance-panel">
    <h1>メンテナンス中</h1>
    <p>現在メンテナンス中です。ご不便をおかけしますが、しばらくお待ちください。</p>
  </section>
</main>
} @else {
<app-isbe-auth />
@if (isLoggedIn) {
<app-header />
<div class="main-content-wrapper">
  <app-screen-message />
  <router-outlet />
</div>
}
}
